// Google reCAPTCHA (score based, invisible) for public storefront forms (TD1-10671).
// The API verifies the token; this side only loads the script and asks for a token.
// Any failure resolves to null so the form still submits and the API decides.

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const TOKEN_TIMEOUT_MS = 5000;

let loading = null;

export const loadRecaptcha = () => {
  if (!SITE_KEY || typeof window === 'undefined') return Promise.resolve(null);
  if (!loading) {
    loading = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${SITE_KEY}`;
      script.async = true;
      script.onload = () =>
        window.grecaptcha.enterprise.ready(() => resolve(window.grecaptcha.enterprise));
      script.onerror = () => {
        loading = null;
        resolve(null);
      };
      document.head.appendChild(script);
    });
  }
  return loading;
};

export const getRecaptchaToken = (action) => {
  const token = loadRecaptcha()
    .then((grecaptcha) => (grecaptcha ? grecaptcha.execute(SITE_KEY, { action }) : null))
    .catch(() => null);
  const timeout = new Promise((resolve) => setTimeout(() => resolve(null), TOKEN_TIMEOUT_MS));
  return Promise.race([token, timeout]);
};
